export const arrayBufferConverterToFile = (arrayBuffer: ArrayBuffer, fileName: string): void => {
  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(link.href);
};
